import React, { FC } from 'react';
import { View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import BackButton from '@components/common/backButton';
import { ContainerStyle } from '@interfaces/base';
import DashboardHeaderResultTypeChip from '@v2/pages/dashboard/common/components/DashboardHeaderResultTypeChip';
import { DASHBOARD_BACK_BUTTON_FONT_TYPE, DASHBOARD_BACK_BUTTON_ICON_CONFIG } from '@v2/pages/dashboard/common/constants/backButton';
import { isPhone } from '@helpers';

export interface DashboardDrilldownHeaderProps extends WithColor, ContainerStyle {
  onBack: () => void;
}

const DashboardDrilldownHeader: FC<DashboardDrilldownHeaderProps> = ({ onBack, containerStyle }) => {
  return (
    <View style={[{ flexDirection: 'row', alignItems: 'center', gap: scale(12), marginLeft: -scale(12) }, containerStyle]}>
      <BackButton
        backArrow
        text="Dashboard"
        onPress={onBack}
        fontType={DASHBOARD_BACK_BUTTON_FONT_TYPE}
        iconConfig={DASHBOARD_BACK_BUTTON_ICON_CONFIG}
      />
      {!isPhone && <DashboardHeaderResultTypeChip />}
    </View>
  );
};

export default ColorWrapper(DashboardDrilldownHeader);
